<div class="card">
  <div class="card-body">
    <h5 class="card-title">Abstract Values Download</h5>
    <div class="description">
      Export final coding for all abstracts, for the selected fiscal year, one row per abstract.
    </div>
    <div *ngIf="years" class="mt-2">
      <mat-form-field>
        <mat-label>FY</mat-label>
        <mat-select matNativeControl #year aria-label="select year" value="All" required>
          <mat-option value="All">All FYs</mat-option>
          <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-button type="submit" class="btn btn-success my-2 d-block" (click)="onSubmit(year.value)">
        Run Report
      </button>
    </div>
  </div>
</div>
